import { render, staticRenderFns } from "./HomeCards.vue?vue&type=template&id=18bcb670&scoped=true&"
import script from "./HomeCards.vue?vue&type=script&lang=ts&"
export * from "./HomeCards.vue?vue&type=script&lang=ts&"
import style0 from "./HomeCards.vue?vue&type=style&index=0&id=18bcb670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcb670",
  null
  
)

export default component.exports